import { BEGIN, COMMIT, REVERT } from 'redux-optimistic-ui';
import APIService from '../../services/APIService';
import { Apis } from '../../constants';

const _REQUEST = '_REQUEST';
const _SUCCESS = '_SUCCESS';
const _FAILURE = '_FAILURE';

/*
  dispatch({
    type: ADD_GEOTAG_URL_REQUEST,
    payload: { url },
    meta: {
      isOptimistic: true,
      url: `/board/${boardId}/geolocation`,
      method: 'POST',
    }
  })
*/

let nextTransactionID = 0;

export default () => (next: Function) => async (action: any) => {
  const { type, payload, meta = {} } = action;
  const { isOptimistic, method, url, api = Apis.CORE, ...metaRest } = meta;

  if (!meta || !isOptimistic) return next(action);

  const transactionID = (nextTransactionID += 1);

  next(Object.assign({}, action, { meta: { optimistic: { type: BEGIN, id: transactionID }, ...metaRest } }));

  try {
    const data = await APIService[method](url, api, payload);
    return next({
      type: type.replace(_REQUEST, _SUCCESS),
      payload: method === 'PUT' ? data : data.data,
      meta: {
        optimistic: { type: COMMIT, id: transactionID },
        ...metaRest,
      },
    });
  } catch (err) {
    return next({
      type: type.replace(_REQUEST, _FAILURE),
      payload: err,
      error: true,
      meta: {
        optimistic: { type: REVERT, id: transactionID },
        ...metaRest,
      },
    });
  }
};
